import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/common/hooks/useOrganization'
import HgSkeletonPage from '@/common/components/ui/atoms/HgSkeletonPage'
import PageNotFound from '@/common/components/views/PageNotFound'
import PendingPage from '@/pages/organizations/detail/pending'

export const Route = createFileRoute('/app/organizations/$organizationId/pending')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { organizationId: organizationIdParam } = Route.useParams()
  const organizationId = organizationIdParam ? parseInt(organizationIdParam, 10) : null
  const { organization, loading, error } = useOrganization(organizationId)

  if (loading) {
    return <HgSkeletonPage />
  }

  if (error || !organization) {
    return <PageNotFound />
  }

  return <PendingPage organization={organization} />
}
